export const METRICS_LIST = ['Fitscore', 'WT', 'SMM', 'PBF'];

// 그래프 색상 리스트 타입 정의
interface GraphColorItem {
    metricCode: string;
    metricText: string;
    color: string;
}

export const GRAPH_COLOR_LIST: GraphColorItem[] = [
    {
        metricCode: 'Fitscore',
        metricText: '핏스코어',
        color: '#333A4A',
    },
    {
        metricCode: 'WT',
        metricText: '체중',
        color: '#1377C4',
    },
    {
        metricCode: 'SMM',
        metricText: '골격근량',
        color: '#EE3059',
    },
    {
        metricCode: 'PBF',
        metricText: '체지방률',
        color: '#FFA600',
    },
];
